<template lang="pug">
  b-row.mb-5
    b-col
      organizations-form(:action='action')
</template>

<script>
import OrganizationsForm from '@views/container/manager/organizations/Form'

export default {
  name: 'manager-organizations-new',
  components: {
    OrganizationsForm,
  },
  props: {
    action: String,
  },
}
</script>
